import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export type AvnetEbvV3LocaleCurrencyDTO = z.infer<typeof AvnetEbvV3LocaleCurrencyDTORuntype>;
export const AvnetEbvV3LocaleCurrencyDTORuntype = z.enum(['Eur', 'Usd', 'Gbp', 'Jpy']);

export interface AvnetEbvV3CredentialsDTO extends z.infer<typeof AvnetEbvV3CredentialsDTORuntype> {}
export const AvnetEbvV3CredentialsDTORuntype = z.object({
    client_id: z.string(),
    client_secret: z.string(),
    subscription_key: z.string(),
    currency: AvnetEbvV3LocaleCurrencyDTORuntype.nullable(),
});

export interface AvnetEbvV3CredentialsInputDTO extends z.infer<typeof AvnetEbvV3CredentialsInputDTORuntype> {}
export const AvnetEbvV3CredentialsInputDTORuntype = z.object({
    client_id: z.string().optional(),
    client_secret: z.string().optional(),
    subscription_key: z.string().optional(),
    currency: AvnetEbvV3LocaleCurrencyDTORuntype.nullable(),
});

export interface AvnetEbvV3ResponseBodyDTO extends z.infer<typeof AvnetEbvV3ResponseBodyDTORuntype> {}
export const AvnetEbvV3ResponseBodyDTORuntype = z.object({
    data: AvnetEbvV3CredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
